import Hero from "../components/hero/Hero";
import Image11 from "../assets/img11.jpeg"
import Footer from "../components/footer/FooterSimcor";
import Services from "../components/services/Services";

function Service (){
  return(
    <>
      <Hero
        cName="hero-mid"
        heroImg={Image11}
        title="SERVICIOS"
        btnClass="hide"
      />
      <Services/>
      <Footer/>

    </>
  );
};

export default Service;